// Cached in localStorage for offline access — critical for drivers
const CACHED_PROFILE_KEY = 'qluu_cached_user_profile';

// Used when network errors occur during profile fetch, allowing the app to remain functional with the last known profile
export const getCachedProfile = <T>(): T | null => {
  try {
    const raw = localStorage.getItem(CACHED_PROFILE_KEY);
    return raw ? (JSON.parse(raw) as T) : null;
  } catch {
    return null;
  }
};

// Used in login and fetchProfile flows
export const setCachedProfile = <T>(profile: T): void => {
  localStorage.setItem(CACHED_PROFILE_KEY, JSON.stringify(profile));
};

// Clear cached profile on logout
export const clearCachedProfile = (): void => {
  localStorage.removeItem(CACHED_PROFILE_KEY);
};
